import { AxiosError } from 'axios';

/**
 * Extract a user-friendly error message from an unknown error.
 * Handles Axios errors, standard Error objects, and unknown types.
 *
 * @param err - The caught error (typed as unknown)
 * @param fallback - Default message if no better message can be extracted
 * @returns A string error message suitable for display to the user
 */
export function getApiErrorMessage(err: unknown, fallback = 'An unexpected error occurred'): string {
  if (err instanceof AxiosError) {
    const data = err.response?.data as Record<string, unknown> | undefined;
    return (data?.['detail'] as string)
      || (data?.['error'] as string)
      || (data?.['message'] as string)
      || err.message
      || fallback;
  }
  if (err instanceof Error) {
    return err.message || fallback;
  }
  if (typeof err === 'string') {
    return err;
  }
  return fallback;
}
